<template>

        <!-- Sidemenu -->
        <div :class="'o-mainMenu' + isActive">
            <ul class="m-mainMenu__items">
                <li class="a-mainMenu__item">
                    <a href="https://www.adoptujkravicku.sk">Domov</a>
                </li>
                <li class="a-mainMenu__item">
                    <a href="https://www.adoptujkravicku.sk/ako-adoptovat/">Ako adoptovať</a>
                </li>
                <li class="a-mainMenu__item">
                    <a href="https://www.adoptujkravicku.sk/kravicky/">Kravičky</a>
                </li>
                <li class="a-mainMenu__item">
                    <a href="https://www.adoptujkravicku.sk/o-projekte/">O projekte</a>
                </li>
                <li class="a-mainMenu__item">
                    <a href="https://www.adoptujkravicku.sk/kontakt/">Kontakt</a>
                </li>
            </ul>
            <ul class="m-aboutMenu__items">
                <li class="a-aboutMenu__item">
                    <a href="https://www.adoptujkravicku.sk/pravidla-pouzivania/">Pravidlá používania</a>
                </li>
                <li class="a-aboutMenu__item">
                    <a href="https://www.adoptujkravicku.sk/ako-adoptovat/">Návody, tipy a triky</a>
                </li>
                <li class="a-aboutMenu__item">
                    <a href="https://www.adoptujkravicku.sk/vyrobky-zapojene-do-projektu/">Výrobky zapojené do projektu</a>
                </li>
                <li class="a-aboutMenu__item">
                    <a href="https://www.adoptujkravicku.sk/slovenska-mliecna-rodina/">Slovenská mliečna rodina a partneri</a>
                </li>
            </ul>
            <div class="m-socialMenu_items">
                <a href="https://www.facebook.com/AdoptujKravicku/" class="a-socialMenu__item --facebook"><span class="facebook"></span></a>
                <a href="https://www.youtube.com/channel/UC3k1Az5Cg7ItiLvg8loJgVQ" class="a-socialMenu__item --youtube"><span class="youtube"></span></a>
            </div>
            <div class="m-copyrightInfo">
                <p>© 2019 Slovenská mliečna rodina<br>
                Vytvorené v <a href="https://www.oktodigital.com/">okto.digital</a></p>
            </div>
        </div>
        <!-- .Sidemenu -->

</template>



<script>
    export default {
        props: [
            'isActive'
        ],
        mounted() {
            //this.hamburger()
        },
        methods: {
            // mounted
            /*hamburger() {
                // Look for .hamburger
                var hamburger = document.querySelector(".hamburger");
                // On click
                if ( hamburger != null ) {

                    hamburger.addEventListener("click", function() {
                        // Toggle class "is-active"
                        hamburger.classList.toggle("is-active");
                        var menu = document.querySelector(".o-mainMenu");
                        var body = document.querySelector("body");
                        menu.classList.toggle("is-active");
                        body.classList.toggle("menu-open");
                        var controlsBottom = document.querySelector(".dashboradControlsBottom");

                        if ( controlsBottom != null ) {

                            if (body.classList.contains("menu-open")) {            
                                controlsBottom.style.zIndex = 9;
                            }
                            else {
                                controlsBottom.style.zIndex = 10;
                            }
                        }
                    });

                }
            }*/
        }
    }
</script>